import React, { useEffect, useState } from "react";
import BasicEngineLog from "./child/basic-engine";
import MainEngineLog from "./child/main-engine";
import AuxiliryEngineLog from "./child/auxiliry-engine";
import AuxilaryMachinaryLog from "./child/auxilary-machinary";
import AuxilaryRemarksLog from "./child/auxilary-remarks";
import { CargoMachineryTabCom } from "./child/CargoMachineryTabCom";

function ViewEngineLogBook() {
  const [activeTab, setActiveTab] = useState("basic");

  useEffect(() => {
    const lastSelectedKey = localStorage.getItem("engineLogbook") || activeTab;
    setActiveTab(lastSelectedKey);
  }, []);

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-container">
        <ul className="marine-tabs">
          <li
            className={activeTab === "basic" ? "active" : ""}
            onClick={() => handleClick("basic")}
          >
            Basic Engine Log
          </li>
          <li
            className={activeTab === "main" ? "active" : ""}
            onClick={() => handleClick("main")}
          >
            Main Engine Log
          </li>
          <li
            className={activeTab === "auxiliary" ? "active" : ""}
            onClick={() => handleClick("auxiliary")}
          >
            Auxiliary Engine Log
          </li>
          <li
            className={activeTab === "auxiliary machinery" ? "active" : ""}
            onClick={() => handleClick("auxiliary machinery")}
          >
            Auxiliary Machinery
          </li>
          <li
            className={activeTab === "cargo machinery" ? "active" : ""}
            onClick={() => handleClick("cargo machinery")}
          >
            Cargo Machinery
          </li>
          <li
            className={activeTab === "remarks" ? "active" : ""}
            onClick={() => handleClick("remarks")}
          >
            Remarks
          </li>
        </ul>
        {activeTab === "basic" && <BasicEngineLog />}
        {activeTab === "main" && <MainEngineLog />}
        {activeTab === "auxiliary" && <AuxiliryEngineLog />}
        {activeTab === "auxiliary machinery" && <AuxilaryMachinaryLog />}
        {activeTab === "cargo machinery" && <CargoMachineryTabCom />}
        {activeTab === "remarks" && <AuxilaryRemarksLog />}
      </div>
    </>
  );
}

export default ViewEngineLogBook;
